export default class Application {
    constructor(model) {
        this.id = (model && model.id) || null;
        this.internal = (model && model.internal) || null;
        this.showcaseIds = (model && model.showcaseIds) || [];
        this.missionId = (model && model.missionId) || null;
        this.mediaLinks = (model && model.mediaLinks) || [];
    }
}
